import styled from 'styled-components';

import buildSvg from 'assets/build.svg';

export const BuildBackgroundContainer = styled.div`
  width: 100%;
  min-height: 100dvh;
  background-image: url(${buildSvg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
`;

export const Logo = styled.img`
  width: 100%;
  padding: 16px;
  position: absolute;
  bottom: 0;
`;
